import React, { memo } from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';

const BestLabel = () => {
  return <div css={wrapper}>BEST</div>;
};

const wrapper = css`
  width: 1.6875rem;
  height: 1rem;
  background: ${theme.colors.primary500};
  border-radius: 0.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.white};
  font-weight: 400;
  font-size: 0.5625rem;
  line-height: 0.875rem;
  margin-right: 0.375rem;
`;

export default memo(BestLabel);
